import { useMutation } from '@tanstack/react-query';

import BackendService from '../services/backendService';
import useRouterMatch from './useRouterMatch';

const useUploadGeneratorImage = (tenantId: string) => {
  const { mutate: upload } = useMutation(
    async ({
      file,
      coverImageId,
      imageType,
    }: {
      file?: File;
      coverImageId: string;
      imageType: 'generatorCoverImage' | 'generatorBackgroundImage';

      onSuccessFunction?: (coverImageId: string) => void;
    }) => {
      if (!file) return Promise.reject();

      const data = await BackendService.instance.generatorPlugin.getGeneratorCoverImageUploadUrlV2(
        {
          imageId: coverImageId,
          mimeType: file.type,
          imageType: imageType,
        },
      );
      const url = data.data.url;

      await new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open('PUT', url, true);
        xhr.setRequestHeader('Content-Type', file.type);

        xhr.onreadystatechange = function() {
          if (xhr.readyState === 4) {
            if (xhr.status === 200) {
              resolve(xhr.response);
            } else {
              reject(xhr.response);
            }
          }
        };
        xhr.onerror = function(response) {
          reject(response);
        };
        xhr.send(file);
        //return Promise.resolve(undefined);
      });
      await BackendService.instance.markUploadSuccessfulV2(data.data.uploadId, tenantId);
      return Promise.resolve(coverImageId);
    },
    {
      onSuccess: (coverSvgId: string | undefined, { onSuccessFunction }) => {
        if (onSuccessFunction && coverSvgId) {
          onSuccessFunction(coverSvgId);
        }
      },
    },
  );
  return { upload };
};

export default useUploadGeneratorImage;
